import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { HttpClient, HttpEventType, HttpHeaders } from "@angular/common/http";
import { map, catchError, first, mergeMap, finalize, takeUntil } from "rxjs/operators";
import { throwError, fromEvent, Subject } from "rxjs";
import { DOCUMENT } from "@angular/common";
import { AuthServiceGuest } from "../../../services/AuthServiceGuest";
import { ConfigService } from "../../../shared/services/config.service";
import { GuestsService } from '../../../services/GuestsService';
//import { log } from "util";


@Component({
  selector: 'importGuests-dialog',
  templateUrl: './importGuests.dialog.html',
})
export class ImportGuestsDialog {
  private destroy$ = new Subject<void>();
  progress: number = 0;
  loading: boolean = false;
  importResult = new Array();
  isLoaded: boolean = false;
  private _url = '';
  companyid: number = 533;

  constructor(
    public dialogRef: MatDialogRef<ImportGuestsDialog>,
    @Inject(DOCUMENT) private document: Document,
    private http: HttpClient,
    private _AuthService: AuthServiceGuest,
    public _ConfigService: ConfigService, 
    public _GuestsService: GuestsService
  ) {
    try {
      this._url = _ConfigService._serverUrl + '/api/Upload';
      this.companyid = this._GuestsService._selectedCompany.id;
      console.debug('ImportGuestsDialog uploadFile to service ' + this.companyid);

    } catch (e) {
      console.error(e);
    }
  }

  uploadFile() {
    
    let authToken = this._AuthService.getAuthTokenGuests();
   
      if(!this._AuthService.isLoggedInGuests()) {
      window.location.replace('/login');
    } 


    let reqHeader = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + authToken
      //, 'companyid': this.companyid.toString()
    });

    this.loading = true;
    let fileInput = this.document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'

    fromEvent(fileInput, 'change')
      .pipe(
        first(),
        mergeMap(event => {
          const target = event.target as HTMLInputElement;
          const selectedFile = target.files[0];

          let uu = this._url + '?companyid=' + this.companyid.toString();
          console.log(uu);

          return this.http.post<any>(uu, selectedFile, {
            headers: reqHeader,
            reportProgress: true, 
            observe: 'events',
          });
        }),
        finalize(() => {
          fileInput = null;
        }),
        takeUntil(this.destroy$)
      )
      .subscribe(
        event => {
           console.log(event);
          switch (event.type) {
            case HttpEventType.Sent:
              break;
            case HttpEventType.ResponseHeader:
              break;
            case HttpEventType.UploadProgress:
              this.progress = Math.round(event.loaded / event.total * 100);
              break;
            case HttpEventType.Response:
              this.isLoaded = true;
              this.importResult = event.body;
          }
        },

        error => {
          alert(error.message);
          this.loading = false;
          this.progress = 0;
          return throwError(error.message);
        },
        () => {
          this.loading = false;
        }
      );
    fileInput.click();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onSaveClick(): void {
    this.dialogRef.close();
  }
}
